import { ConfettiIcon } from "@phosphor-icons/react";
import { useGo, useTranslate } from "@refinedev/core";
import { Result } from "antd";
import { useAnalytics } from "hooks/useAnalytics";
import { useAntTheme } from "hooks/useAntTheme";
import { useCallback, useEffect } from "react";
import { AnalyticsEvents } from "types/analytics";
import { useGetActiveSubscriptions } from "pages/pricing/hooks/useGetActiveSubscriptions";
import { useGetProducts } from "./hooks/useGetProducts";

const Success: React.FC = () => {
  const t = useTranslate();
  const theme = useAntTheme();
  const { subscriptions: activeSubscription, isLoading } =
    useGetActiveSubscriptions();
  const { products, isLoading: isLoadingProducts } = useGetProducts();
  const go = useGo();
  const { trackEvent } = useAnalytics();
  const handleClick = useCallback(() => {
    go({
      to: `/`,
    });
  }, [go]);
  useEffect(() => {
    if (isLoading || isLoadingProducts || !activeSubscription) return;

    // only send event for a successful user purchase
    if (activeSubscription.license_type === "Standard") {
      const planProduct = activeSubscription.subscribed_products.find(
        (p) => p.product_type === "Plan"
      );
      const product = products.find((p) => p.id === planProduct?.product_id);
      const price = product?.prices.find(
        (p) => p.interval === activeSubscription.billing_interval
      );
      const value = Number(price?.amount ?? 0);
      const currency = price?.currency?.toUpperCase() ?? "USD";
      trackEvent(AnalyticsEvents.Purchase, {
        value,
        currency,
        transaction_id: activeSubscription.id,
        product_name: product?.name,
        product_id: product?.id,
        product_type: product?.product_type,
      });
    }
    setTimeout(() => {
      handleClick();
    }, 4000); // wait so user can read
  }, [
    isLoading,
    isLoadingProducts,
    activeSubscription,
    products,
    trackEvent,
    handleClick,
  ]);

  return (
    <Result
      style={{ paddingTop: "25vh" }}
      icon={<ConfettiIcon size={100} color={theme.colorPrimary} />}
      title={t("pages.pricing.title")}
      status={"success"}
    />
  );
};

export default Success;
